const POST_BOOKING_URL_ENDPOINT = 'postBookingUrl';
const logger = require('od-modules/utils/logger');
const fetcher = require('od-modules/utils/fetcher');

module.exports = {
    /**
     * Performs a request with the provided parameters to retrieve the accommodation postbooking url
     *
     * @param {Object} params - An object containing the parameters for the request.
     * @param {number} params.bookingId - The booking ID.
     * @param {string} params.email - The email address.
     * @param {string} params.buyPath - The buypath
     * @return {Promise<PostbookingURL>} A string with the accomomdation postbooking deeplink
     * @typedef {Object} PostbookingURL
     * @property {string} url
     * @property {boolean} fallbackUrl
     * @throws {Error} If the request is not successful.
     */
    get: async(params) => {
        let result;
        const baseUrl = `${Odigeo.Settings.getProperty('appContext')}/service/v2/${POST_BOOKING_URL_ENDPOINT}`;
        const queryString = Object.keys(params).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
        try {
            result = await fetcher.get(`${baseUrl}?${queryString}`).json();
            return result;
        } catch (error) {
            await logger.error(error, 'Error getting accommodation postbooking url: ', error);
            throw error;
        }
    },
};

